import React, { useEffect, useRef, useState } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import filter from "../../../assets/images/filter.svg";
import BlueFilterIcon from "../../../assets/images/BlueFilterIcon.svg";
import { MultiSelect } from "primereact/multiselect";

const ChangeHandlingHistoryFilter = ({
  historyOp,
  onSort,
  selectedColumnName,
  setSelectedColumnName,
  tableData,
  selectedFields,
  onGlobalFilterChange,
  setFieldUpdated,
  fieldUpdated,
  clearColumnWiseFilter,
  sortData
}) => {
  const [columnWiseSelectedFields, setColumnWiseSelectedFields] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const acpFilterRef = useRef();
  let isACPFilterClicked = useRef(false);

  useEffect(() => {
    const handleClick = (event) => {
      if (acpFilterRef?.current) {
        isACPFilterClicked.current = acpFilterRef?.current?.contains(event.target);
      }
    };

    document.addEventListener("click", handleClick, true);

    return () => document.removeEventListener("click", handleClick, true);
  }, [acpFilterRef]);

  // Utility to normalize all rows to flat objects for consistent option extraction and filtering
  const normalizeRows = (data) => {
    return data.map(row => (row && typeof row === 'object' && 'data' in row ? row.data : row));
  };

  // Utility to robustly extract unique options for a column from any data structure, as strings
  const getColumnOptions = (data, colName) => {
    const flatRows = normalizeRows(data);
    const values = flatRows
      .map(row => row && row[colName])
      .filter(v => v !== undefined && v !== null && v !== '');
    // Convert all to string for consistent matching
    return Array.from(new Set(values.map(String)));
  };

  // In the filter popup rendering logic, use getColumnOptions to generate options
  const options = getColumnOptions(tableData, selectedColumnName);

  useEffect(() => {
  }, []);

  useEffect(() => {
    if (selectedFields && selectedColumnName) {
      const val = selectedFields[selectedColumnName];
      setColumnWiseSelectedFields(Array.isArray(val) ? val : val ? [val] : []);
    }
  }, [selectedFields, selectedColumnName]);

  // Filter options by search value
  const filteredOptions = options.filter(opt =>
    opt?.toString().toLowerCase().includes(searchValue.toLowerCase())
  );

  // MultiSelect expects options as array of objects with label/value, not primitives
  const multiSelectOptions = filteredOptions.map(opt => ({ label: String(opt), value: opt }));

  // Defensive: always ensure MultiSelect value is a flat array of primitives (as strings)
  const getSafeArray = val => {
    if (Array.isArray(val)) {
      return val.flat(Infinity).filter(v => v !== undefined && v !== null && (typeof v !== 'object' && typeof v !== 'function')).map(String);
    }
    if (val === undefined || val === null) return [];
    return [String(val)];
  };
  const safeColumnWiseSelectedFields = getSafeArray(columnWiseSelectedFields).filter(v =>
    multiSelectOptions.some(opt => opt.value === v || opt.value?.toString() === v?.toString())
  );
  const safeMultiSelectOptions = Array.isArray(multiSelectOptions) ? multiSelectOptions : [];
  
  const handleMultiselectOptionClose = () => {
    if(!isACPFilterClicked.current) {
      setSelectedColumnName && setSelectedColumnName(null);
      historyOp?.current?.hide();
    }
  }

  return (
    <span>
      <OverlayPanel className="overlay" ref={historyOp}>
        <div className="acp-filters" ref={acpFilterRef}>
          <div className="clearAllFilterMainDiv">
            <div
              id="clearAllFilter"
              className="clearAllFilter"
              onClick={() => {
                clearColumnWiseFilter();
                setFieldUpdated && setFieldUpdated(!fieldUpdated);
              }}
            >
              Clear Column filter
            </div>
            <div className="clearAllFilterDiv" >
              <img
                src={filter}
                alt="filter logo"
                onClick={() => clearColumnWiseFilter()}
                className="header-icons"
              />
            </div>
          </div>
          <div
            id="sortZtoA"
            className="sortAndFrozen"
            onClick={() => onSort(selectedColumnName, "desc")}
          >
            {sortData?.[0] === selectedColumnName && sortData?.[1] === "desc" ? (
              <div className="sort-label">Sort z to a</div>
            ) : (
              <div>Sort z to a</div>
            )}
          </div>
          <div
            id="sortAtoZ"
            className="sortAndFrozen"
            onClick={() => onSort(selectedColumnName, "asc")}
          >
            {sortData?.[0] === selectedColumnName && sortData?.[1] === "asc" ? (
              <div className="sort-label">Sort a to z</div>
            ) : (
              <div>Sort a to z</div>
            )}
          </div>
          <div className="multiSelect">
            <MultiSelect
              value={safeColumnWiseSelectedFields}
              onChange={e => {
                let val = getSafeArray(e.value).filter(v =>
                  safeMultiSelectOptions.some(opt => opt.value === v || opt.value?.toString() === v?.toString())
                );
                setColumnWiseSelectedFields(val);
                // Always pass string values to filter handler for consistency
                onGlobalFilterChange({ value: val }, selectedColumnName); // Pass as event object
              }}
              options={safeMultiSelectOptions}
              optionLabel="label"
              optionValue="value"
              filter={true}
              filterTemplate={(options) => (
                <div className="filter-container">
                  {options && options.element}
                </div>
              )}
              placeholder={`Select ${selectedColumnName}`}
              maxSelectedLabels={3}
              className="p-column-filter"
              style={{ width: "100%" }}
              panelClassName="dsbpScreen-multiselect-dropdown"
              itemTemplate={option => <div>{option.label}</div>}
              onHide={() => handleMultiselectOptionClose()}
            />
          </div>
        </div>
      </OverlayPanel>
    </span>
  );
};

export default ChangeHandlingHistoryFilter;
